export const COMBO_DEFS = [
  {
    slug: 'wedding-bridesmaid-set',
    name: 'The Wedding Bridesmaid Set',
    tagline: 'Everything she needs for the perfect ethnic look',
    occasion: 'Wedding & Festive',
    badge: 'Most Popular',
    badgeColor: '#8B1A1A',
    accent: '#8B1A1A',
    categories: ['juttis', 'necklaces', 'bracelets'],
    categoryLabels: ['Punjabi Jutti', 'Kundan Necklace', 'Bangle Set'],
  },
  {
    slug: 'festive-glam-set',
    name: 'The Festive Glam Set',
    tagline: 'Head-to-toe ethnic elegance for every celebration',
    occasion: 'Diwali & Navratri',
    badge: 'Festival Special',
    badgeColor: '#D4A017',
    accent: '#D4A017',
    categories: ['earrings', 'rings', 'potli-bags'],
    categoryLabels: ['Ethnic Earrings', 'Statement Ring', 'Potli Bag'],
  },
];
